import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { AuthProvider } from "@/context/AuthContext";
import AuthDialog from "@/components/auth/AuthDialog";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import DesktopNotice from "@/components/DesktopNotice";
import Home from "@/pages/Home";
import ThankYou from "@/pages/ThankYou";
import Account from "@/pages/Account";
import PricingPage from "@/pages/PricingPage";
import AboutPage from "@/pages/AboutPage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import PlanDetail from "@/pages/PlanDetail";
import Console from "@/pages/Console";
import LegalPage from "@/pages/LegalPage";
import SupportChat from "@/components/SupportChat";
import {
  SUPPORT_DOC, PLATFORM_DOC, PRIVACY_DOC, TERMS_DOC, REFUND_DOC, ACCEPTABLE_DOC,
  EULA_DOC, LEGAL_DOC, DELETE_ACCOUNT_DOC, DELETE_DATA_DOC,
} from "@/data/legal";

const LEGAL_ROUTES = [
  { path: "/support.html", doc: SUPPORT_DOC },
  { path: "/platform-disclaimer.html", doc: PLATFORM_DOC },
  { path: "/privacy-policy.html", doc: PRIVACY_DOC },
  { path: "/terms.html", doc: TERMS_DOC },
  { path: "/refund-policy.html", doc: REFUND_DOC },
  { path: "/acceptable-use.html", doc: ACCEPTABLE_DOC },
  { path: "/eula.html", doc: EULA_DOC },
  { path: "/legal.html", doc: LEGAL_DOC },
  { path: "/delete-account.html", doc: DELETE_ACCOUNT_DOC },
  { path: "/delete-data.html", doc: DELETE_DATA_DOC },
];

function ScrollManager() {
  const { pathname } = window.location;
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false} disableTransitionOnChange>
      <div className="App min-h-screen bg-background text-foreground">
        <BrowserRouter>
          <AuthProvider>
            <ScrollManager />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/plans/:slug" element={<PlanDetail />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/account" element={<Account />} />
              <Route path="/console" element={<Console />} />
              {LEGAL_ROUTES.map((r) => (
                <Route key={r.path} path={r.path} element={<LegalPage doc={r.doc} />} />
              ))}
              <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
            <AuthDialog />
            <SupportChat />
          </AuthProvider>
        </BrowserRouter>
        <DesktopNotice />
        <Toaster position="top-center" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
